module.exports = __webpack_public_path__ + "static/img/anteslogo_3.4b37118e.png";